export default "__VITE_ASSET__CrjppaDu__"